import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";

export const useRemoveSubscription = (
  projectId: string,
  topicName: string,
  userExternalId: string,
  options: Omit<UseMutationOptions<void, ErrorResponse, void, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<void, ErrorResponse, void, unknown>({
    mutationFn: async (): Promise<void> => {
      await api.delete(`/projects/${projectId}/users/${userExternalId}/subscriptions/${encodeURIComponent(topicName)}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "topics", topicName, "subscriptions"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "users", userExternalId, "subscriptions"],
      });
    },
    ...options
  });
};
